
export class TenantLayout {
    logo!: string;
}

export class TenantWebPush {
    subscriptions!: number;
}

export class TenantBilling {
    invoice_name_template = "{year}-{month}";
    invoice_prefix = "INV";
    invoice_reminders_enabled = true;
    iban_account = "";
}

export class TenantURLs {
    account = "https://account.galactic-group.nl";
    payment = "https://pay.galactic-group.nl";
}

export class Tenant {
    id!: string;
    name!: string;
    layout!: TenantLayout;
    webpush!: TenantWebPush;
    billing: TenantBilling = new TenantBilling();
    urls: TenantURLs = new TenantURLs();
}
